//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SupervisorAssignmentSelect',
  props: {
    supervisors: {
      type: Array,
      default: () => [],
    },
    supervisorSelected: {
      type: Object,
      default: null,
    },
    supervisorAssignment: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selected: null,
      innerValue: '',
    }
  },
  created() {
    if (this.supervisorSelected) {
      this.innerValue = this.supervisorSelected.label
      this.selected = this.supervisorSelected
    }
  },
  methods: {
    selectSupervisor(option) {
      if (option && option.value) {
        this.$emit('select', {
          supervisorId: option.value,
          projectId: this.supervisorAssignment.project,
          collaboratorId: this.supervisorAssignment.collaborator.id,
        })
        this.selected = option
      }
    },

    showSupervisorSelected() {
      if (
        this.supervisorSelected &&
        (this.innerValue === '' ||
          this.innerValue === null ||
          this.innerValue !== this.supervisorSelected)
      ) {
        this.innerValue = this.supervisorSelected.label
        this.selected = this.supervisorSelected
      }
    },
  },
}
